import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { WorkflowTypes } from '~/state/atoms/viewerAtoms';
import AiAssistantButton from '../../AiAssistantButton';
import StepHeader from '../StepHeader';
import DatasetPicker from './DatasetPicker/DatasetPicker';
import StructureSet from './StructureSet/StructureSet';

/**
 * The Contouring step: its title, the AI assistant and the dataset picker
 * on top, then the structure list of the selected structure set, or a note
 * that the image has none loaded.
 */
export default function ContouringContent() {
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    return (
        <Box
            height="100%"
            position="relative"
            display="grid"
            gridTemplateColumns="minmax(0, 1fr)"
        >
            <Box
                position="relative"
                display="grid"
                gridTemplateRows="auto 1fr"
                gridTemplateColumns="minmax(0, 1fr)"
            >
                <Box>
                    <StepHeader titleId="workflow.contouring" />
                    {/* No bottom padding: the structure list's own top
                        padding is the only space below the picker. */}
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={1.5}
                        px={2}
                        mt={1}
                    >
                        <AiAssistantButton page={WorkflowTypes.CONTOUR} />
                        <DatasetPicker />
                    </Box>
                </Box>
                {selectedPatientId && currentStructureSet ? (
                    <Box height="100%" display="grid">
                        <StructureSet
                            structureSet={currentStructureSet}
                            selectHint={
                                <FormattedMessage id="workflow.contouring.selectStructureToEdit" />
                            }
                        />
                    </Box>
                ) : (
                    selectedPatientId && (
                        <Typography
                            fontSize={12}
                            color="text.secondary"
                            px={2}
                            py={1.5}
                            data-testid="no-structure-set-loaded"
                        >
                            <FormattedMessage id="structure.noStructureSetLoaded" />
                        </Typography>
                    )
                )}
            </Box>
        </Box>
    );
}
